import packageJson from '@/../package.json';
import { env } from '@/config/env';

/**
 * Analytics configuration
 * Centralizes all analytics-related constants and metadata
 */
export const analyticsConfig = {
  /**
   * Google Analytics Measurement ID
   */
  measurementId: env.GA_MEASUREMENT_ID,

  /**
   * Application metadata
   */
  app: {
    name: packageJson.name,
    version: packageJson.version,
    description: packageJson.description,
    environment: env.NODE_ENV,
  },

  /**
   * Common event parameters to include with all events
   */
  defaultParams: {
    app_name: packageJson.name,
    app_version: packageJson.version,
    app_environment: env.NODE_ENV,
  },

  /**
   * Debug mode (enabled in development)
   */
  debug: env.NODE_ENV === 'development',
} as const;

export type AnalyticsConfig = typeof analyticsConfig;
